import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import { hideConsentBanner } from '../../redux/actions/consentBanner'
import { IState } from '../../redux/state'
import { ConsentBanner as ConsentBannerComponent } from './ConsentBanner'
import { PropsFromDispatch, PropsFromState } from './props'

const actionCreators = {
  hideConsentBanner: hideConsentBanner,
}

const mapStateToProps = (state: IState): PropsFromState => {
  const { showConsentBanner } = state.ui
  return { showConsentBanner }
}

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

// tslint:disable-next-line:variable-name
export const ConsentBanner = connect(mapStateToProps, mapDispatchToProps)(ConsentBannerComponent)
